export async function publishRiderBookingUseCase(repository, booking) {
  return await repository.publish(booking);
}
